module.exports = __webpack_public_path__ + "assets/img/jump.74b835e5.png";